// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, Tag, Td, Tooltip, Tr, useDisclosure } from "@chakra-ui/react"
import { Form, Icon, IconButton, Scope, Searchable, Section, Table } from "components"

// Config
import { Mask, Enums, Moment } from "config"

// Hooks
import { useDistributorsCashHistory } from "hooks"

// Screens
import Add from "./add"

export default function Extract({ data:distributor, ...props }){

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState()
    const [ operation, setOperation ] = useState()
    const history = useDistributorsCashHistory(distributor.data?.id, page, term, operation)
    const add = useDisclosure()

    const columns = [
        { children: '' }, 
        { children: 'Descrição' }, 
        { children: 'Valor', isNumeric: true }, 
        { children: 'Data', isNumeric: true }
    ]

    return(
    <>
        <Section title="Extrato financeiro">
            <ButtonGroup size="xs" isDisabled={history.isFetching}>
                <Scope role="distributors_cash"><Button colorScheme="orange" children="Nova movimentação" leftIcon={<Icon name="add" />} onClick={add.onOpen} /></Scope>
                <IconButton icon="refresh" label="Atualizar" isLoading={history.isFetching} onClick={history.refetch} />
            </ButtonGroup>
        </Section>

        <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por descrição..">
            <Form.Select onChange={e => setOperation(e.target.value)} options={[{ label: 'Todos', value: '' }, { label: 'Adicionado', value: 1 }, { label: 'Removido', value: 2 }]} />
        </Searchable>

        <Table columns={columns} setPage={setPage} meta={history.data?.meta} loading={history.isLoading}>
            { history.data?.data?.map(item => <Item key={item.id} data={item} />) }
        </Table>

        {/* Screens */}
        <Add {...add} data={history} distributor={distributor} />
    </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td isTruncated maxW="100px" children={item.cod} />
        <Td fontSize="xs">{item.label}</Td>
        <Td isNumeric><Tooltip label={item?.operation_label}><Tag size="sm" colorScheme={Enums.BonusOperation.data(item.operation).colorScheme} children={`R$ ${Mask.price(item.amount)}`} /></Tooltip></Td>
        <Td isNumeric children={Moment(item.created_at).calendar()} />
    </Tr>
)